import { LuBellRing } from "react-icons/lu";

export const BellRingIcon = ({ ...rest }) => {
  return <LuBellRing {...rest} />;
};
